import { render, staticRenderFns } from "./Scorer.vue?vue&type=template&id=28b2cab3&"
import script from "./Scorer.vue?vue&type=script&lang=ts&"
export * from "./Scorer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports